import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import Hero from "../components/Hero";
import ContactForm from "../components/ContactForm";
import { courses } from "../data/courses";
import CardCourse from "../components/CardCourse";
import LatestGuides from "../components/LatestGuides";
import instructorImage from "../assets/instructor.jpg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const CustomPrevArrow = ({ onClick }) => (
  <div
    className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer bg-white shadow p-2 rounded-full hover:bg-gray-200 hover:scale-110 transition duration-200 ease-in-out"
    onClick={onClick}
  >
    <FaChevronLeft />
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div
    className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer bg-white shadow p-2 rounded-full hover:bg-gray-200 hover:scale-110 transition duration-200 ease-in-out"
    onClick={onClick}
  >
    <FaChevronRight />
  </div>
);

export default function Home() {
  const [slidesToShow, setSlidesToShow] = useState(3);

  const updateSlidesToShow = () => {
    const width = window.innerWidth;
    if (width < 640) {
      setSlidesToShow(1);
    } else if (width < 960) {
      setSlidesToShow(2);
    } else {
      setSlidesToShow(3);
    }
  };

  useEffect(() => {
    updateSlidesToShow(); // Chạy 1 lần khi component mount
    window.addEventListener("resize", updateSlidesToShow); // Theo dõi resize
    return () => window.removeEventListener("resize", updateSlidesToShow); // Cleanup
  }, []);

  return (
    <div className="w-full">
      <Helmet>
        <title>Học lái xe ô tô TP.HCM | Trung tâm dạy lái xe Quốc uy tín</title>
        <meta
          name="description"
          content="Trung tâm dạy lái xe Quốc tại TP.HCM, hơn 10 năm kinh nghiệm, tỷ lệ đậu 95%. Đăng ký học lái xe ô tô B2, C nhanh chóng."
        />
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Trung tâm dạy lái xe Quốc",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "TP.HCM",
              "addressCountry": "VN"
            }
          }
          `}
        </script>
      </Helmet>

      {/* Hero (tách riêng) */}
      <Hero />

      <h1 className="text-3xl md:text-4xl font-bold text-center mt-6">
        Trung tâm dạy lái xe - Quốc - Học lái xe ô tô uy tín tại TP.HCM
      </h1>
      <p className="text-center text-sm text-gray-600 mt-4">
        Hỗ trợ học lái xe cho sinh viên Làng Đại học thành phố Dĩ An - linh hoạt
        thời gian, chi phí phù hợp
      </p>

      {/* Giới thiệu ngắn */}
      <section className="flex flex-col md:flex-row items-center gap-6 max-w-4xl mx-auto py-12 px-4">
        <img
          src={instructorImage}
          alt="Giáo viên dạy lái xe ô tô tại TP.HCM - Nguyễn Lê Thanh Quốc"
          className="w-48 h-48 rounded-full object-cover border-4 border-red-500"
        />
        <div>
          <h2 className="text-3xl font-bold mb-2">Giới thiệu giáo viên</h2>
          <p>
            <strong>Họ tên:</strong> Nguyễn Lê Thanh Quốc
          </p>
          <p>
            <strong>Chứng chỉ:</strong> GPLX hạng DCE
          </p>
          <p>
            <strong>Kinh nghiệm:</strong> Hơn 10 năm dạy lái xe
          </p>
          <p>
            <strong>Tỷ lệ học viên đậu:</strong> 95% đậu ngay lần đầu
          </p>
          <p className="text-gray-800">
            Trung tâm của chúng tôi cam kết mang lại những khóa học chất lượng,
            dễ hiểu và hiệu quả, giúp học viên tự tin khi tham gia giao thông.
          </p>
        </div>
      </section>

      {/* Khóa học nổi bật */}

      <LatestGuides />
      <section className="py-12 bg-gray-50">
        <h2 className="text-3xl font-bold text-center mb-8">
          Khóa học nổi bật
        </h2>

        <div className="max-w-6xl mx-auto px-4">
          <Slider
            slidesToShow={slidesToShow}
            slidesToScroll={1}
            autoplay
            autoplaySpeed={2500}
            infinite
            arrows
            prevArrow={<CustomPrevArrow />}
            nextArrow={<CustomNextArrow />}
          >
            {courses.map((course) => (
              <div key={course.id} className="px-2">
                <CardCourse course={course} />
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* CTA cuối cùng */}
      <section className="py-12 bg-yellow-100">
        <div className="max-w-3xl mx-auto text-center">
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
